import { Navigate } from "react-router";
import { ListPageLayout } from "@/components/list-page-layout";
import { usePermissions } from "@/hooks/auth/use-permissions";
import { useCustomChannelsRulesManagementEnabled } from "@/hooks/use-feature-flags";
import { usePageTitle } from "@/hooks/use-page-title";
import { RulesManager } from "./rules-manager";

export default function CustomChannelsRules() {
  usePageTitle("Custom Channels Rules");

  const customChannelsRulesManagementEnabled =
    useCustomChannelsRulesManagementEnabled();
  const { isAdmin } = usePermissions();

  // Check permissions - only admins with feature flag enabled can access
  if (!customChannelsRulesManagementEnabled || !isAdmin) {
    return <Navigate to="/home" replace />;
  }

  return (
    <ListPageLayout
      pageType="custom-channels::rules"
      title="Custom Channels Rules"
      ariaLabel="Custom Channels Rules Management"
      headingId="custom-channels-rules-heading"
      className="max-w-full"
      hideViewSelector
    >
      <RulesManager />
    </ListPageLayout>
  );
}
